export default [
  { action: `manage`, subject: `client` },
  { action: `manage`, subject: `workorder` },
  { action: `manage`, subject: `bait` },
  { action: `manage`, subject: `report` },
];
